
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
components: {
XHeader
},

props: {
leftOptions: Object,
title: String,
transition: String,
rightOptions: {
type: Object,
default () {
return {
showMore: false
}
}
}
},

methods: {
close () {
window.opener = null
window.open('', '_self')
window.close()
}
},

computed: {
_leftOptions () {
return this.noHistory ? {
showBack: false
} : this.leftOptions
},

noHistory () {
return window.history.length === 1
},
donotshow () {
return ['/wpgwishes'].includes(this.$route.path)
}
}
}
